import { log } from '@/services/logging-service'
import { getUserId, hasValidUserSession } from '@/services/identity-client'
import layerService from '@/services/layer-service'
import { setIsIdle, viewerDimension } from '@/services/map-service'
import marketingEventService from '@/services/marketing-event-service'
import markupService from '@/services/markup-service'

/**
 * Update events with additional external information
 * and pass to marketing events
 * @param {Object} e - event from map viewer
 */
export const eventHandler = async (e) => {
  // Update events with external data
  if (e.name === 'main_activity_started') {
    await mainActivityStarted(e)
    setIsIdle(true)
  }

  if (e.name === 'map_viewport_changed') {
    mapViewportChanged(e)
  }

  // event type publishers
  const sendFunc = {
    // amplitude
    event: marketingEventService.publish.bind(marketingEventService),
    // firebase
    performance: log,
  }

  const func = sendFunc[e.type]
  const name = e.name
  // Clean object meta not needed for reporting
  delete e.type
  delete e.name
  func(name, e)
}

/**
 * Update main activity started event
 * @param {Object} e - event from map viewer
 */
const mainActivityStarted = async (e) => {
  const [validSession, userId] = await Promise.all([
    hasValidUserSession(),
    getUserId(),
  ])

  if (validSession && userId) {
    // append UTM params if available otherwise set to null
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    e.utm_source = urlParams.get('utm_source')
    e.utm_medium = urlParams.get('utm_medium')
    e.utm_campaign = urlParams.get('utm_campaign')
    e.utm_term = urlParams.get('utm_term')
    e.utm_content = urlParams.get('utm_content')
    // update reference
    e.account_id = userId
    e.total_state_collections_enabled =
      layerService.getActiveStateCollections().length
  }
}

/**
 * Update map viewport changed event
 * @param {Object} e - event from map viewer
 */
const mapViewportChanged = (e) => {
  e.visible_markup_count = markupService.getAllVisible()?.length || 0
  e.map_viewer_dimension = viewerDimension()
}
